<script>
  import { afterUpdate } from "svelte"
  import { loadTooltip } from "../../../../../Script/loadTooltip"
  import { getRequest } from "../../../../../Script/apiMethods"
  import notify from "../../../../../Script/notify"
  import Loader from "../../../../../Shared/Slots/loader.svelte"

  export let seal = {}

  let showImage = false

  let showLoading = false

  let imageBlob
  /**
   * @typedef {Object} closeNotification
   * @property {Function} close - Closes the notification.
   */
  let closeNotification = {
    close() {},
  }

  afterUpdate(() => {
    loadTooltip()
    window.addEventListener("resize", loadTooltip)
  })

  const handlePreview = async () => {
    try {
      showImage = true
      if (imageBlob) return
      showLoading = true

      const fileData = await getRequest(`/seal/file/${seal.image}`, { responseType: "blob" })
      imageBlob = URL.createObjectURL(fileData)
    } catch (error) {
      // console.error(error)
      showImage = false
      closeNotification.close()
      const info = "PAGE: List of Seal\nEVENT: While fetching Seal Image"
      closeNotification = notify.danger(error, info)
    } finally {
      showLoading = false
    }
  }
</script>

{#if showImage}
  {#if showLoading}
    <Loader>
      <span class="flex">Loading Seal&nbsp;&nbsp;</span>
    </Loader>
  {:else}
    <!-- svelte-ignore a11y-click-events-have-key-events -->
    <div
      class="fixed inset-0 -top-3 z-30 flex h-full w-full cursor-pointer flex-col items-center justify-center bg-[#000000cc] first:top-0"
      on:click|preventDefault|stopPropagation={() => {
        showImage = false
      }}
    >
      <img style="background: url(assets/img/grid.png);" on:click|stopPropagation src={imageBlob} class="relative flex max-h-[80vh] min-w-[300px] max-w-[390px] cursor-default rounded-md mobile:p-0 sm:max-w-[700px]" alt="sealImage" />
      <div class="mb-6 mt-3 text-lg font-semibold text-white mobile:text-xl">To close preview, click within the black area.</div>
    </div>
  {/if}
{/if}

<div class="flex w-full items-center justify-between rounded-md border-2 border-transparent bg-white py-2 px-3 text-white hover:shadow-md dark:bg-lightgray dark:hover:border-blue-500">
  <div class="flex flex-col truncate pl-2">
    <h2 title={seal.name} class="select-none truncate text-sm font-bold text-gray-d00 dark:text-white/70 md:text-lg">
      {seal.name}
    </h2>
    <p class="mt-2 w-full select-none truncate text-xs font-normal text-gray-200 md:text-sm">
      <i class="fa-solid fa-calendar-days" />
      &nbsp;&nbsp;{new Date(seal.created).toString().slice(0, 24)}
    </p>
  </div>

  <button on:click={handlePreview} type="button" name="tooltip" id="View Seal" tooltip-position="top" class="ml-auto flex cursor-pointer select-none items-center justify-center rounded-full px-3 py-2 text-sm font-medium text-yellow-500 hover:bg-yellow-500 hover:text-white focus:outline-none active:text-white sm:px-5">
    <i class="fa-solid fa-eye" />
    <span class="hidden lg:block">&nbsp;&nbsp;View&nbsp;Seal</span>
  </button>
</div>
